import getHost from './getHost'
import prependSlashMaybe from './prependSlashMaybe'

export default (path = '') =>
  `${getHost()}${prependSlashMaybe(process.env.PUBLIC_URL)}${prependSlashMaybe(
    encodeURI(path)
  )}`



// WEBPACK FOOTER //
// ./src/utils/getURL.js